import { createStore, applyMiddleware, compose } from "redux";
import promiseMiddleware from "redux-promise-middleware";
// import logger from 'redux-logger'
import rootReducer from "./../reducers";

//for redux dev Tool
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(promiseMiddleware /* logger, */))
    // applyMiddleware(promiseMiddleware /* logger, */)
  );
}

const store = configureStore();
export default store;
